import { c as _c } from "react/compiler-runtime";
import { getOrgApiKeysQueryKey, postOrgApiKeysByIdRevealMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { DashboardSecretApiKey, OffsetPaginatedDashboardSecretApiKey } from '@onefootprint/request-types/dashboard';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
const AUTO_HIDE_DELAY = 5000; // 5 seconds

const useRevealKey = apiKey => {
  const $ = _c(23);
  const queryClient = useQueryClient();
  const showRequestError = useRequestErrorToast();
  const timeoutRef = useRef(undefined);
  let t0;
  if ($[0] !== apiKey || $[1] !== queryClient) {
    t0 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
      queryClient.setQueryData(getOrgApiKeysQueryKey(), prevData => {
        if (!prevData) {
          return prevData;
        }
        return {
          ...prevData,
          data: prevData.data.map(key => key.id === apiKey.id ? {
            ...key,
            key: undefined
          } : key)
        };
      });
    };
    $[0] = apiKey;
    $[1] = queryClient;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const hide = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = postOrgApiKeysByIdRevealMutation();
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== apiKey || $[5] !== hide || $[6] !== queryClient) {
    t2 = response => {
      queryClient.setQueryData(getOrgApiKeysQueryKey(), prevData_0 => {
        if (!prevData_0) {
          return prevData_0;
        }
        return {
          ...prevData_0,
          data: prevData_0.data.map(key_0 => key_0.id === apiKey.id ? {
            ...key_0,
            key: response.key
          } : key_0)
        };
      });
      timeoutRef.current = setTimeout(() => {
        hide();
      }, AUTO_HIDE_DELAY);
    };
    $[4] = apiKey;
    $[5] = hide;
    $[6] = queryClient;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== showRequestError || $[9] !== t2) {
    t3 = {
      ...t1,
      onSuccess: t2,
      onError: showRequestError
    };
    $[8] = showRequestError;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const mutation = useMutation(t3);
  let t4;
  if ($[11] !== apiKey || $[12] !== mutation) {
    t4 = async () => {
      await mutation.mutateAsync({
        path: {
          id: apiKey.id
        }
      });
    };
    $[11] = apiKey;
    $[12] = mutation;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const show = t4;
  let t5;
  if ($[14] !== apiKey || $[15] !== hide || $[16] !== show) {
    t5 = async () => {
      if (apiKey.key) {
        hide();
      } else {
        await show();
      }
    };
    $[14] = apiKey;
    $[15] = hide;
    $[16] = show;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const toggle = t5;
  let t6;
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    t7 = [];
    $[18] = t6;
    $[19] = t7;
  } else {
    t6 = $[18];
    t7 = $[19];
  }
  useEffect(t6, t7);
  let t8;
  if ($[20] !== mutation || $[21] !== toggle) {
    t8 = {
      toggle,
      mutation
    };
    $[20] = mutation;
    $[21] = toggle;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default useRevealKey;